import navIcon from '../assets/icons/nav-icon.svg';
import { BiRightArrowAlt, BiLeftArrowAlt } from 'react-icons/bi'
import modalCloseIcon from "../assets/icons/modal-back-icon.svg";


export const useIcons = () => {
  return {
    navIcon,
    leftArrow: BiLeftArrowAlt,
    rightArrow: BiRightArrowAlt,
    modalCloseIcon
  };
};

